// extracted by mini-css-extract-plugin
module.exports = {"input":"_2Q6fMLBD","searchButton":"xnEXAafn"};